import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import ElectricBlanket from '@elem/SVGIcon/PowerBackup/ElectricBlanket';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import EFPicture from 'elem/compCommon/EFPicture';
import ElectricGrill from 'elem/SVGIcon/OutdoorRecreation/ElectricGrill';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import AirConditioner from 'elem/SVGIcon/PowerBackup/AirConditioner';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import Light from 'elem/SVGIcon/PowerBackup/Light';
import Microwave from 'elem/SVGIcon/PowerBackup/Microwave';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

export default function F_Other({ callBuy }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const ZA_SITE: string[] = ['za'];

    const cards: any = [
        {
            img: '/responsive/picture/common-products/delta2.png',
            power: t('secF_card1_power'),
            title: t('secF_card1_title'),
            tag: t('common_card_tag_best_seller'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-2-portable-power-station',
                    de: 'https://de.ecoflow.com/products/delta-2-portable-power-station',
                    za: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/delta-2-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/delta-2-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/delta-2-portable-power-station',
                    it: 'https://it.ecoflow.com/products/delta-2-portable-power-station',
                    es: 'https://es.ecoflow.com/products/delta-2-portable-power-station',
                    au: 'https://au.ecoflow.com/collections/new-product-launch/products/delta-2-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/delta-max-1600-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6806217719881',
                    ca: '7440912384154',
                    de: '7742214308087',
                    za: '7187057803473',
                    fr: '7838178017506',
                    eu: '7403706253476',
                    uk: '7335539867840',
                    it: '7778985246961',
                    es: '7766079799518',
                    au: '7756517146822',
                    kr: '7429923700905',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40569176326217',
                    ca: '43725896056986',
                    de: '43148797739255',
                    za: '41620506575057',
                    fr: '43231886704866',
                    eu: '42596003512484',
                    uk: '43099247608000',
                    it: '43166053925105',
                    es: '43293121380574',
                    au: '42768126181574',
                    kr: '43452341551273',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon2_desc'),
                },
                {
                    icon: <Projector className="card-icon" />,
                    title: t.rich('secF_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon3_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon4_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon5_desc'),
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon6_desc'),
                },
            ],
        },
        {
            img: `/responsive/picture/common-products/delta${ZA_SITE.includes(locale) ? '' : '2max'}.png`,
            power: t('secF_card2_power'),
            title: t('secF_card2_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station',
                    de: 'https://de.ecoflow.com/products/delta-2-max-portable-power-station',
                    za: 'https://za.ecoflow.com/products/delta-portable-power-station',
                    fr: 'https://fr.ecoflow.com/products/delta-2-max-portable-power-station',
                    eu: 'https://eu.ecoflow.com/products/delta-2-max-portable-power-station',
                    uk: 'https://uk.ecoflow.com/products/delta-2-max-portable-power-station',
                    it: 'https://it.ecoflow.com/products/delta-2-max-portable-power-station',
                    es: 'https://es.ecoflow.com/products/delta-2-max-portable-power-station',
                    au: 'https://au.ecoflow.com/products/delta-max-portable-power-station',
                    kr: '',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                    de: '8513034813775',
                    za: '7027756007633',
                    fr: '8431233794395',
                    eu: '8414996627799',
                    uk: '8416984367443',
                    it: '8415773360477',
                    es: '8435033899355',
                    au: '6837457256646',
                    kr: '',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                    de: '46739567706447',
                    za: '41630469652689',
                    fr: '46793751789915',
                    eu: '46790633881943',
                    uk: '46679851139411',
                    it: '46891073274205',
                    es: '46787970269531',
                    au: '41762129117382',
                    kr: '',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon2_desc'),
                },
                {
                    icon: <Projector className="card-icon" />,
                    title: t.rich('secF_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon3_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon4_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon5_desc'),
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon6_desc'),
                },
            ],
        },
        {
            img: '/responsive/picture/common-products/deltamax.png',
            power: t('secF_card3_power'),
            title: t('secF_card3_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-max-portable-power-station',
                    ca: 'https://ca.ecoflow.com/products/delta-max-portable-power-station',
                    de: '',
                    za: 'https://za.ecoflow.com/products/delta-max-portable-power-station',
                    fr: '',
                    eu: '',
                    uk: '',
                    it: '',
                    es: '',
                    au: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                    de: '8513034813775',
                    za: '7027758235857',
                    eu: '',
                    uk: '',
                    it: '',
                    es: '',
                    au: '7220911505606',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                    de: '46739567706447',
                    za: '41620506902737',
                    eu: '',
                    uk: '',
                    it: '',
                    es: '',
                    au: '42736222142662',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon2_desc'),
                },
                {
                    icon: <Projector className="card-icon" />,
                    title: t.rich('secF_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon3_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secF_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon4_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon5_desc'),
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon6_desc'),
                },
            ],
        },
    ];
    const euCards = [
        {
            img: ``,
            power: t('secF_card1_power'),
            title: t('secF_card1_title'),
            tag: t('common_card_tag_hot_pale'),
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-3-series-portable-power-station?variant=49573797626199',
                    uk: 'https://uk.ecoflow.com/products/delta-3-series-portable-power-station?variant=49833569026387',
                    de: 'https://de.ecoflow.com/products/delta-3-series-portable-power-station?variant=53707200037199',
                    fr: 'https://fr.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526901899611',
                    it: 'https://it.ecoflow.com/products/delta-3-series-portable-power-station?variant=54819109339512',
                    es: 'https://es.ecoflow.com/products/delta-3-series-portable-power-station?variant=49526969172315',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '9744704930135',
                    uk: '9616877420883',
                    de: '14848608960847',
                    fr: '9594942095707',
                    it: '14845588341112',
                    es: '9594953924955',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '49573797626199',
                    uk: '49833569026387',
                    de: '53707200037199',
                    fr: '49526901899611',
                    it: '54819109339512',
                    es: '49526969172315',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card1_icon6_desc'),
                },
            ],
        },
        {
            img: ``,
            power: t('secF_card2_power'),
            title: t('secF_card2_title'),
            tag: '',
            link_more: (() => {
                const localMap: any = {
                    eu: 'https://eu.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48911033270615',
                    uk: 'https://uk.ecoflow.com/products/delta-pro-3-portable-power-station?variant=49296152723795',
                    de: 'https://de.ecoflow.com/products/delta-pro-3-portable-power-station?variant=49424786358607',
                    fr: 'https://fr.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799611879771',
                    it: 'https://it.ecoflow.com/products/delta-pro-3-portable-power-station?variant=52783177990493',
                    es: 'https://es.ecoflow.com/products/delta-pro-3-portable-power-station?variant=48799731024219',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    eu: '9488706797911',
                    uk: '9430243180883',
                    de: '9480253407567',
                    fr: '9375271846235',
                    it: '9646835597661',
                    es: '9375312970075',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    eu: '48911033270615',
                    uk: '49296152723795',
                    de: '49424786358607',
                    fr: '48799611879771',
                    it: '52783177990493',
                    es: '48799731024219',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon1_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon2_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon3_desc'),
                },
                {
                    icon: <ElectricBlanket className="card-icon" />,
                    title: t.rich('secF_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon4_desc'),
                },
                {
                    icon: <ElectricGrill className="card-icon" />,
                    title: t.rich('secF_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card2_icon6_desc'),
                },
            ],
        },
        {
            img: ``,
            power: t('secF_card3_power'),
            title: t('secF_card3_title'),
            tag: t('common_card_tag_hot_pale'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/delta-2-max-portable-power-station?variant=46739567706447',
                    fr: 'https://fr.ecoflow.com/products/delta-2-max-portable-power-station?variant=46793751789915',
                    eu: 'https://eu.ecoflow.com/products/delta-2-max-portable-power-station?variant=46790633881943',
                    uk: 'https://uk.ecoflow.com/products/delta-2-max-portable-power-station?variant=46679851139411',
                    it: 'https://it.ecoflow.com/products/delta-2-max-portable-power-station?variant=46891073274205',
                    es: 'https://es.ecoflow.com/products/delta-2-max-portable-power-station?variant=46787970269531',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '8513034813775',
                    fr: '8431233794395',
                    eu: '8414996627799',
                    uk: '8416984367443',
                    it: '8415773360477',
                    es: '8435033899355',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '46739567706447',
                    fr: '46793751789915',
                    eu: '46790633881943',
                    uk: '46679851139411',
                    it: '46891073274205',
                    es: '46787970269531',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card3_icon6_desc'),
                },
            ],
        },
        {
            img: '',
            power: t('secF_card4_power'),
            title: t('secF_card4_title'),
            tag: t('common_card_tag_best_seller'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/delta-2-portable-power-station?variant=43148797739255',
                    fr: 'https://fr.ecoflow.com/products/delta-2-portable-power-station?variant=43231886704866',
                    eu: 'https://eu.ecoflow.com/products/delta-2-portable-power-station?variant=42596003512484',
                    uk: 'https://uk.ecoflow.com/products/delta-2-portable-power-station?variant=43099247608000',
                    it: 'https://it.ecoflow.com/products/delta-2-portable-power-station?variant=43166053925105',
                    es: 'https://es.ecoflow.com/products/delta-2-portable-power-station?variant=43293121380574',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7742214308087',
                    fr: '7838178017506',
                    eu: '7403706253476',
                    uk: '7335539867840',
                    it: '7778985246961',
                    es: '7766079799518',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '43148797739255',
                    fr: '43231886704866',
                    eu: '42596003512484',
                    uk: '43099247608000',
                    it: '43166053925105',
                    es: '43293121380574',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secF_card4_desc1'), t('secF_card4_desc2'), t('secF_card4_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secF_card4_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secF_card4_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon2_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secF_card4_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secF_card4_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secF_card4_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secF_card4_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secF_card4_icon6_desc'),
                },
            ],
        },
    ];
    let list = [];
    if (ZA_SITE.includes(locale)) {
        list = cards;
    } else if (['kr'].includes(locale)) {
        list = cards.slice(0, 1);
    } else if (['au'].includes(locale)) {
        list = [
            {
                showGoodDesign: true,
                img: '/responsive/picture/common-products/delta2.png',
                power: t('secF_card1_power'),
                title: t('secF_card1_title'),
                link_more: 'https://au.ecoflow.com/collections/new-product-launch/products/delta-2-portable-power-station',
                productId: '7756517146822',
                variantId: '42768126181574',
                descArr: [t('secF_card1_desc1'), t('secF_card1_desc2'), t('secF_card1_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card1_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card1_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon2_desc'),
                    },
                    {
                        icon: <Projector className="card-icon" />,
                        title: t.rich('secF_card1_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon3_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secF_card1_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon4_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card1_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon5_desc'),
                    },
                    {
                        icon: <ElectricGrill className="card-icon" />,
                        title: t.rich('secF_card1_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card1_icon6_desc'),
                    },
                ],
            },
            {
                img: `/responsive/picture/common-products/delta${ZA_SITE.includes(locale) ? '' : '2max'}.png`,
                power: t('secF_card2_power'),
                title: t('secF_card2_title'),
                tag: t('common_card_tag_best_seller'),
                link_more: 'https://au.ecoflow.com/products/delta-max-portable-power-station',
                productId: '6837457256646',
                variantId: '41762129117382',
                descArr: [t('secF_card2_desc1'), t('secF_card2_desc2'), t('secF_card2_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card2_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card2_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon2_desc'),
                    },
                    {
                        icon: <CarFridge className="card-icon" />,
                        title: t.rich('secF_card2_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card2_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card2_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card2_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card2_icon6_desc'),
                    },
                ],
            },
            {
                img: '/responsive/picture/common-products/delta2max.png',
                power: t('secF_card4_power'),
                title: t('secF_card4_title'),
                tag: t('common_card_tag_new_arrival'),
                link_more: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
                productId: '7914502422726',
                variantId: '43045698371782',
                descArr: [t('secF_card4_desc1'), t('secF_card4_desc2'), t('secF_card4_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card4_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card4_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon2_desc'),
                    },
                    {
                        icon: <Refrigerator className="card-icon" />,
                        title: t.rich('secF_card4_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card4_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card4_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card4_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card4_icon6_desc'),
                    },
                ],
            },
            {
                img: '/responsive/picture/common-products/deltapro_au.png',
                power: t('secF_card3_power'),
                title: t('secF_card3_title'),
                link_more: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
                productId: '7220911505606',
                variantId: '42736222142662',
                descArr: [t('secF_card3_desc1'), t('secF_card3_desc2'), t('secF_card3_desc3')],
                iconArr: [
                    {
                        icon: <Light className="card-icon" />,
                        title: t.rich('secF_card3_icon1_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon1_desc'),
                    },
                    {
                        icon: <Phone className="card-icon" />,
                        title: t.rich('secF_card3_icon2_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon2_desc'),
                    },
                    {
                        icon: <CarFridge className="card-icon" />,
                        title: t.rich('secF_card3_icon3_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon3_desc'),
                    },
                    {
                        icon: <CoffeeMaker className="card-icon" />,
                        title: t.rich('secF_card3_icon4_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon4_desc'),
                    },
                    {
                        icon: <Microwave className="card-icon" />,
                        title: t.rich('secF_card3_icon5_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon5_desc'),
                    },
                    {
                        icon: <AirConditioner className="card-icon" />,
                        title: t.rich('secF_card3_icon6_title', {
                            s: (text: string) => <span className="s-text">{text}</span>,
                        }),
                        desc: t('secF_card3_icon6_desc'),
                    },
                ],
            },
        ];
    } else {
        list = cards.slice(0, 2);
    }
    if (['eu', 'uk', 'fr', 'it', 'es', 'de'].includes(locale)) {
        list = euCards;
    }
    const [cardLists, setCardLists] = useState(list);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Outdoor Recreation Page_${card?.title}`,
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            callBuy({
                discountPrice: card?.discountPrice,
                originalPrice: card?.originalPrice,
                inventory: card?.inventory,
                productId: card?.productId,
                variantId: card?.variantId,
                img: card?.img,
                title: card?.title,
                skuTitle: card?.skuTitle,
            });
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    useEffect(() => {
        const tempArr = list;
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        // tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        tempArr[k].inventory = res?.data?.inventoryPolicy === 'continue' ? 9999 : res?.data?.inventoryQuantity ?? undefined;
                        if (!tempArr[k].img && res?.data?.variantImg) {
                            tempArr[k].img = res?.data?.variantImg || res?.data?.img;
                        }
                        // tempArr[k].inventory = 1;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="outdoor-recreation-F" className={`outdoor-recreation-F ${css['outdoor-recreation-F']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secF_title')}</p>
                </div>
                <Swiper className="cards swiper-box" effect="fade" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                    {cardLists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            {card?.tag && <span className="card-tag">{card?.tag}</span>}
                            {card?.showGoodDesign && (
                                <div className="card-good-design">
                                    <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                </div>
                            )}
                            <EFPicture src={card?.img} alt={card?.title} />
                            <p className="card-power">{card?.power}</p>
                            <p className="card-title">{card?.title}</p>
                            <ul className="card-descs">
                                {card?.descArr?.map((desc: any, m: number) => (
                                    <li className="card-desc" key={`${k}_${m}`}>
                                        {desc}
                                    </li>
                                ))}
                            </ul>
                            <ul className="card-icons">
                                {card?.iconArr?.map((icon: any, n: number) => (
                                    <li className="card-icon-item" key={`${k}_${n}`}>
                                        {icon?.icon}
                                        <p className="icon-title">{icon?.title}</p>
                                        <p className="icon-desc">{icon?.desc}</p>
                                    </li>
                                ))}
                            </ul>
                            <div className="card-btns">
                                {card?.link_buy && (
                                    <>
                                        {Number(card?.inventory) <= 0 ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={
                                            ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)
                                                ? card?.link_more
                                                : `${card?.link_more}${
                                                      String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                                  }utm_source=scenario+page&utm_medium=Pillar`
                                        }
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secF_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
